import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import Textarea from 'components/ui-kit/Textarea/Textarea';
import { useTranslation } from 'react-i18next';
import { MAX_REVIEW_LENGTH } from 'services/shop-feedback.service';

type Props = {
  productImage?: string;
  sellerName?: string;
  feedback: string;
  setFeedback: (v: string) => void;
  error: string;
  onBack: () => void;
};

const FeedbackView = ({ productImage, sellerName, feedback, setFeedback, error, onBack }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="item-received-feedback-view">
      <IconButton className="item-received-feedback-view__back" onClick={onBack}>
        <ArrowBackIcon />
      </IconButton>

      {productImage && <img src={productImage} alt="" className="item-received-feedback-view__image" />}

      <p className="item-received-feedback-view__title">{t('components.feedback.write-review-title')}</p>

      <Textarea
        value={feedback}
        onChange={setFeedback}
        placeholder={t('components.feedback.review-placeholder', { name: sellerName })}
        maxLength={MAX_REVIEW_LENGTH}
        variant="modal"
      />

      {error && <p className="item-received-feedback-view__error">{error}</p>}
    </div>
  );
};

export default FeedbackView;
